/**
 * Shared types and utilities for the remittances table layout.
 *
 * Layout modes control which columns are visible at different screen widths:
 * - full     (xl, >= 1536px): All columns
 * - standard (lg, 1200-1535px): Drop Method
 * - compact  (md, 900-1199px): Date, Payer, Amount, Claims only
 * - card     (< 900px): Stacked card layout
 */

export type TableLayoutMode = 'full' | 'standard' | 'compact' | 'card';

export const GRID_GAP = 1.5;

/**
 * Returns the CSS Grid `gridTemplateColumns` value for a given layout mode.
 *
 * Column order:
 *   full:     Date(100) Payer(1fr) Trace#(0.8fr) Method(90) Amount(110) Claims(70) Denials(70)
 *   standard: Date(100) Payer(1fr) Trace#(0.8fr) Amount(110) Claims(70) Denials(70)
 *   compact:  Date(100) Payer(1fr) Amount(100) Claims(60)
 *   card:     Not applicable
 */
export function getGridTemplateColumns(layout: TableLayoutMode): string {
  switch (layout) {
    case 'full':
      return '100px 1fr 0.8fr 90px 110px 70px 70px';
    case 'standard':
      return '100px 1fr 0.8fr 110px 70px 70px';
    case 'compact':
      return '100px 1fr 100px 60px';
    case 'card':
      return '';
  }
}
